import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { outside_pages, user_view } from "./Helper";

// Function to handle redirection for visitors --shrithi, 12/13/2024
function handleRedirect() {
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    let redirect_link = null;

    if (user_view === "visitor" && outside_pages === false) {
        // Changed logic for profile redirection --shrithi, 12/13/2024
        if (currentUrl.includes("/profile/")) {
            const profileIndex = urlParts.indexOf("profile");
            const name = urlParts[profileIndex + 1];
            redirect_link = `/login?name=${name}&action=profile`;
        }

        // Changed logic for courses redirection --shrithi, 12/13/2024
        if (currentUrl.includes("/courses/")) {
            const coursesIndex = urlParts.indexOf("courses");
            if (coursesIndex !== -1) {
                const name = urlParts[coursesIndex + 1];
                const id = urlParts[coursesIndex + 2];
                redirect_link = `/login?action=courses&name=${name}&id=${id}`;
            }
        }

        // Changed logic for community redirection --shrithi, 12/13/2024
        if (currentUrl.includes("/community/")) {
            const communityIndex = urlParts.indexOf("community");
            const name = urlParts[communityIndex + 1];
            redirect_link = `/login?name=${name}&action=community`;
        }

        if (redirect_link) {
            console.log("Redirect Link:", redirect_link);
            window.location.href = redirect_link; // Changed redirection logic --shrithi, 12/13/2024
        }
    }
}

// Function to handle redirection based on user_view --shrithi, 12/13/2024
function handlePageRedirection() {
    if ((["/"].includes(window.location.pathname) && user_view !== "visitor") || outside_pages === false) {
        if (user_view === "admin") {
            window.location.pathname = "/schedule-webinar"; // Changed redirection path --shrithi, 12/13/2024
        } else if (user_view === "webinar") {
            window.location.pathname = "/og-webinars"; // Changed redirection path --shrithi, 12/13/2024
        } else if (user_view === "academy") {
            window.location.pathname = "/dashboard"; // Changed redirection path --shrithi, 12/13/2024
        }
    }
}

function Example() {
    useEffect(() => {
        handlePageRedirection(); // Added call to handlePageRedirection --shrithi, 12/13/2024
        handleRedirect(); // Added call to handleRedirect --shrithi, 12/13/2024
    }, [window.location.pathname]);

    return <div></div>;
}

export default Example;
